/**
 * O authus criou a sessão do Stytch na migração, mas o cliente não conseguiu carregá-la
 * (`hydrateSessionWithTokens` devolveu `false`).
 */
export class SessionHydrationError extends Error {
  readonly errorType = "stytch_hydrate_failed";

  constructor() {
    super("Não foi possível carregar a sessão do Stytch criada pela migração");
    this.name = "SessionHydrationError";
  }
}
